const tagFilterFunction = slug => {
  return event => event.tagSlugs.includes(slug);
};

const collectionFilterFunction = slug => {
  return event => event.collectionSlugs.includes(slug);
};

const curatedCollectionFilterFunction = slug => {
  return event => event.curatedCollectionSlugs.includes(slug);
};

const FILTER_FUNC_MAP = {
  'tag': tagFilterFunction,
  'collection': collectionFilterFunction,
  'curator': curatedCollectionFilterFunction,
};

class Option {
  slug;
  name;

  constructor(data, type) {
    this.slug = data.slug;
    this.name = data.name;
    this.image = data.image;
    this.type = type;

    this.filter = this.filter.bind(this);
  }

  filter(event) {
    const func = FILTER_FUNC_MAP[this.type](this.slug);
    return func(event);
  }
}

class Filter {
  options = [];

  constructor(data) {
    this.id = data.id;
    this.label = data.label;
    this.url = data.url;

    data.options.forEach(option => {
      this.options.push(new Option(option, this.url));
    });
  }

  getOptionBySlug(slug) {
    return this.options.find(option => option.slug === slug);
  }
}

export default class FilterList {
  filters = [];

  constructor(data) {
    if (data) {
      data.forEach(filter => {
        this.filters.push(new Filter(filter));
      });
    }
  }

  get hasFilters() {
    return this.filters.length > 0;
  }

  getFilterByTypeAndSlug(type, slug) {
    const filter = this.filters.find(f => f.url === type);
    return filter.getOptionBySlug(slug);
  }
}
